import { render } from "./DriveItems.vue?vue&type=template&id=382ddeec&scoped=true&ts=true"
import script from "./DriveItems.vue?vue&type=script&lang=ts"
export * from "./DriveItems.vue?vue&type=script&lang=ts"

import "./DriveItems.vue?vue&type=style&index=0&id=382ddeec&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382ddeec"]])

export default __exports__